// 這是Webpack掛載起始點
import Index from './index.vue'
import Edit from '../.components/provider/edit.vue'
import New from '../.components/provider/new.vue'

const main_router = 'provider_operations'
const new_router = 'new_provider_operation'
const edit_router = 'edit_provider_operation'

const router = [
    {
        path: '',
        component: Index,
        name: 'provider_operations',
        meta: {
            api_name: 'api_v1_provider_operations',
            breadcrumb: [main_router],
            btns: [new_router],
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_provider_operation',
        meta: {
            api_name: 'api_v1_provider_operations_create',
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: 'edit/:identity',
        component: Edit,
        name: 'edit_provider_operation',
        meta: {
            api_name: 'api_v1_provider_operation_update',
            breadcrumb: [main_router ,edit_router]
        }
    },
]

export default router
